import { functions } from '@/main.js'

async function publish_site(site_id) {
  return functions.httpsCallable('site-publish_site')({site_id: site_id})
}

async function stripe_request_setupintent() {
  return functions.httpsCallable('payments-stripe_request_setupintent')({})
}

async function stripe_add_card(payment_method_id) {
  return functions.httpsCallable('payments-stripe_add_card')({payment_method_id})
}

async function update_site_plan(site_id, key, value) {
  return functions.httpsCallable('payments-update_site_plan')({site_id, key, value})
}

async function check_content_credits() {
  return functions.httpsCallable('content-check_credits')({})
}

async function check_tasks() {
  return functions.httpsCallable('tasks-check_tasks')({})
}

async function add_location(data) {
  return functions.httpsCallable('citations-add_location')(data)
}

async function add_campaign(site_id, location_id) {
  return functions.httpsCallable('citations-add_campaign')({site_id, location_id})
}

async function check_campaign(site_id, location_id, campaign_id, brightlocal_campaign_id) {
  return functions.httpsCallable('citations-check_campaign')({site_id, location_id, campaign_id, brightlocal_campaign_id})
}

async function search_icon(query) {
  return functions.httpsCallable('storage-search_icon')({query})
}

async function check_deploy_queue() {
  return functions.httpsCallable('site-check_deploy_queue')({})
}



export default {
  publish_site,
  stripe_add_card,
  stripe_request_setupintent,
  update_site_plan,
  check_tasks,
  check_content_credits,
  add_location,
  add_campaign,
  check_campaign,
  search_icon,
  check_deploy_queue
}
